// New Shopify Integration - Simple Braze Tracking
(function () {
  const shopifyBase = "https://smartnursece.myshopify.com/";
  const learnBase = "https://learn.nursegrid.com/";
  const baseURL = window.location.href.startsWith(shopifyBase)
    ? shopifyBase
    : learnBase;
  const COOKIE_NAME = "ngbc";

  function getCookie(name) {
    const match = document.cookie.match(
      new RegExp(
        "(?:^|; )" +
          name.replace(/([.$?*|{}()\[\]\\/+^])/g, "\\$1") +
          "=([^;]*)"
      )
    );
    return match ? decodeURIComponent(match[1]) : "";
  }

  function setNgcbCookie(value) {
    try {
      const expires = new Date(
        Date.now() + 365 * 24 * 60 * 60 * 1000
      ).toUTCString();
      document.cookie = `${COOKIE_NAME}=${encodeURIComponent(
        value
      )}; expires=${expires}; path=/; Secure; SameSite=None`;
      console.log("[Debug] Set ngbc cookie to:", value);
    } catch (e) {
      console.warn("[Debug] Failed to set ngbc cookie:", e);
    }
  }

  function extractFromUrl(prefix) {
    const urlWithoutParams = window.location.href.split("?")[0];
    if (!urlWithoutParams.startsWith(prefix)) return "";
    const urlPart = urlWithoutParams.slice(prefix.length);
    return urlPart.split("/")[0];
  }

  function setCustomAttribute(userObj, attributeName, value) {
    console.log("[Debug] Setting custom attribute:", attributeName, value);
    try {
      if (userObj && typeof userObj.addToCustomAttributeArray === "function") {
        const result = userObj.addToCustomAttributeArray(attributeName, value);
        console.log("[Debug] addToCustomAttributeArray result:", result);
        if (braze && braze.requestImmediateDataFlush) {
          braze.requestImmediateDataFlush();
        }
        return result;
      }
      console.warn("[Debug] addToCustomAttributeArray not available");
      return false;
    } catch (error) {
      console.error("[Debug] Error setting custom attribute:", error);
      return false;
    }
  }

  function removeUtmParams(url) {
    const urlObj = new URL(url);
    urlObj.searchParams.forEach((value, key) => {
      if (key.startsWith("utm_")) {
        urlObj.searchParams.delete(key);
      }
    });
    return urlObj.toString();
  }

  function checkAndLogPageView() {
    if (typeof braze === "undefined" || !braze.isInitialized()) {
      console.warn("[Debug] Braze not initialized, skipping page view");
      return;
    }
    const cleanUrl = window.location.href;
    const userObj = braze.getUser();
    console.log("[Debug] Current URL:", cleanUrl);
    console.log(
      "[Debug] User ID:",
      userObj ? userObj.getUserId() : "undefined"
    );

    if (cleanUrl.includes(`${baseURL}products/`)) {
      const productName = extractFromUrl(`${baseURL}products/`);
      if (productName) {
        console.log("[Debug] Product page detected:", productName);
        braze.logCustomEvent("viewed_product_page", { product: productName });
        if (userObj) {
          setCustomAttribute(userObj, "viewed_products_pages", productName);
        }
      }
    } else if (cleanUrl.includes(`${baseURL}collections/`)) {
      const collectionName = extractFromUrl(`${baseURL}collections/`);
      if (collectionName) {
        console.log("[Debug] Collection page detected:", collectionName);
        braze.logCustomEvent("viewed_collection_page", {
          collection: collectionName,
        });
        if (userObj) {
          setCustomAttribute(
            userObj,
            "viewed_collections_pages",
            collectionName
          );
        }
      }
    }

    if (braze.requestImmediateDataFlush) {
      braze.requestImmediateDataFlush();
    }
  }

  function getUserFromQueryParam() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("user");
  }

  function waitForNewShopifyBraze(callback) {
    let attempts = 0;
    const maxAttempts = 100;
    const interval = 200;

    function check() {
      attempts++;
      if (
        typeof braze !== "undefined" &&
        typeof braze.isInitialized === "function" &&
        braze.isInitialized()
      ) {
        console.log("[Debug] Shopify Braze integration is ready");
        const userFromUrl = getUserFromQueryParam();
        if (userFromUrl) {
          console.log(
            "[Debug] Found ?user= in URL. Setting cookie and calling changeUser:",
            userFromUrl
          );
          setNgcbCookie(userFromUrl);
          braze.changeUser(userFromUrl);
        } else {
          const cookieUser = getCookie(COOKIE_NAME);
          if (cookieUser) {
            console.log(
              "[Debug] Using user from ngbc cookie. Calling changeUser:",
              cookieUser
            );
            braze.changeUser(cookieUser);
          }
        }
        setTimeout(() => {
          console.log(
            "[Debug] Current Braze user:",
            braze.getUser() ? braze.getUser().getUserId() : "undefined"
          );
          callback();
        }, 500);
        return;
      }
      if (attempts < maxAttempts) {
        setTimeout(check, interval);
      } else {
        console.warn(
          "[Debug] Shopify Braze integration not ready after max attempts"
        );
        callback();
      }
    }

    check();
  }

  function initNewShopifyBraze() {
    waitForNewShopifyBraze(function () {
      console.log(
        "[Debug] New Shopify Braze integration ready, logging page view"
      );
      checkAndLogPageView();
      document.addEventListener("page:load", checkAndLogPageView);
      document.addEventListener("turbolinks:load", checkAndLogPageView);
      window.addEventListener("popstate", checkAndLogPageView);
      window.addEventListener("hashchange", checkAndLogPageView);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initNewShopifyBraze);
  } else {
    initNewShopifyBraze();
  }
})();